var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ big: _vm.big, small: !_vm.big, wrapper: true }},[_c('div',{staticClass:"showPlacement"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.info)+" ")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }